import { toast, type ToastOptions, type Id } from "react-toastify";

type ToastMessage = string;

export const useAISearchToast = () =>
  (msg: ToastMessage, options: ToastOptions = {}): Id =>
    toast(msg, { ...options, toastId: "ai-search-toast" });

export const useAISearchErrorToast = () => {
  const toastFn = useAISearchToast();
  return (msg: ToastMessage, options: ToastOptions = {}): Id =>
    toastFn(msg, { ...options, type: "error" });
};
